import { h, Component } from 'preact'

interface CountdownState {
  timeLeft: string
  days: number
  hours: number
  minutes: number
  seconds: number
}

interface CountdownProps {
  'end-date': string
}

export class CountdownElement extends Component<CountdownProps, CountdownState> {
  private timer: number | null = null
  private endTime: number = 0

  constructor() {
    super()
    this.updateCountdown = this.updateCountdown.bind(this)
    this.state = {
      timeLeft: '',
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    }
  }

  componentDidMount() {
    const endDate = this.props['end-date']
    if (endDate) {
      this.endTime = new Date(endDate).getTime()
      this.updateCountdown()
      this.timer = window.setInterval(this.updateCountdown, 1000)
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  updateCountdown() {
    const now = new Date().getTime()
    const timeDiff = this.endTime - now

    if (timeDiff < 1) {
      this.setState({
        timeLeft: '',
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      })
      if (this.timer) {
        clearInterval(this.timer)
      }
      window.location.reload()
      return
    }

    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
    const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000)

    this.setState({
      timeLeft: `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds`,
      days,
      hours,
      minutes,
      seconds
    })
  }

  render() {
    if (this.state.timeLeft === 'Available now!') {
      return h('span', { class: 'text-xs' }, 'Available now!')
    }

    return h('div', { class: 'flex gap-x-1.25' }, [
      h('div', { class: 'flex flex-col gap-y-0.5 items-center justify-center text-center' }, [
        h('span', { class: 'text-4xl font-heading font-semibold leading-none' }, this.state.days.toString().padStart(2, '0')),
        h('span', { class: 'text-xxs font-semibold uppercase' }, 'Days')
      ]),
      h('div', { class: 'flex flex-col gap-y-0.5 items-center justify-center text-center' }, [
        h('span', { class: 'text-4xl font-heading font-semibold leading-none' }, this.state.hours.toString().padStart(2, '0')),
        h('span', { class: 'text-xxs font-semibold uppercase' }, 'Hrs')
      ]),
      h('div', { class: 'flex flex-col gap-y-0.5 items-center justify-center text-center' }, [
        h('span', { class: 'text-4xl font-heading font-semibold leading-none' }, this.state.minutes.toString().padStart(2, '0')),
        h('span', { class: 'text-xxs font-semibold uppercase' }, 'Mins')
      ]),
      h('div', { class: 'flex flex-col gap-y-0.5 items-center justify-center text-center' }, [
        h('span', { class: 'text-4xl font-heading font-semibold leading-none' }, this.state.seconds.toString().padStart(2, '0')),
        h('span', { class: 'text-xxs font-semibold uppercase' }, 'Secs')
      ])
    ])
  }
}
